import { useState, useEffect } from "react";
import Navbar from './Navbar';

export default function Shop() {
  const [glowing, setGlowing] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Redirect after showing loading animation for 3 seconds
    const redirectTimer = setTimeout(() => {
      window.location.href = "https://4-finger-studios-shop.fourthwall.com/pages/mediocre-makers";
    }, 3000);

    // Glowing animation effect
    const glowInterval = setInterval(() => {
      setGlowing(prev => !prev);
    }, 2000);

    // Cleanup timers
    return () => {
      clearTimeout(redirectTimer);
      clearInterval(glowInterval);
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white overflow-hidden relative">
      {/* Navbar - properly implemented */}
      <Navbar currentPage="SHOP" />
      
      {/* Background elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-0 w-full h-full bg-blue-900 opacity-20"></div>
        <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-blue-400 blur-3xl opacity-20"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 rounded-full bg-blue-500 blur-3xl opacity-20"></div>
        <div className="absolute bottom-40 left-1/4 w-24 h-24 rounded-full bg-blue-300 blur-3xl opacity-10"></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 pt-20 flex items-center justify-center h-screen">
        <div className="text-center px-6">
          <div className={`logo-container mb-8 ${glowing ? 'animate-pulse' : ''}`}>
            <div className="w-64 h-64 mx-auto relative">
              <div className="absolute inset-0 bg-cyan-400 opacity-20 rounded-full blur-lg"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="border-2 border-cyan-400 w-56 h-40 relative">
                  {/* Top diamond point */}
                  <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 rotate-45 border-2 border-cyan-400 bg-black"></div>
                  {/* Bottom diamond point */}
                  <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 w-12 h-12 rotate-45 border-2 border-cyan-400 bg-black"></div>
                  
                  {/* Small circles */}
                  <div className="absolute -left-2 top-1/4 w-4 h-4 rounded-full border-2 border-cyan-400 bg-black"></div>
                  <div className="absolute -right-2 top-1/4 w-4 h-4 rounded-full border-2 border-cyan-400 bg-black"></div>
                  <div className="absolute -left-2 bottom-1/4 w-4 h-4 rounded-full border-2 border-cyan-400 bg-black"></div>
                  <div className="absolute -right-2 bottom-1/4 w-4 h-4 rounded-full border-2 border-cyan-400 bg-black"></div>
                  
                  {/* Text */}
                  <div className="absolute inset-0 flex flex-col items-center justify-center p-2">
                    <div className="text-cyan-400 text-4xl font-bold tracking-wider leading-none">
                      <div>THE</div>
                      <div>MEDIOCRE</div>
                      <div>SHOP</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <h1 className="text-4xl font-bold mb-4 text-white">
            <span className="text-cyan-400">Redirecting</span> to Shop
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mb-8">
            Taking you to our store where mediocrity meets merchandise.
          </p>
          
          {/* Loading animation */}
          <div className="flex justify-center items-center gap-2 mt-6">
            <div className="h-px w-16 bg-gradient-to-r from-transparent via-cyan-400 to-transparent max-w-md mx-auto animate-pulse"></div>
            <div className="text-cyan-400 animate-pulse">Loading...</div>
            <div className="h-px w-16 bg-gradient-to-r from-transparent via-cyan-400 to-transparent max-w-md mx-auto animate-pulse"></div>
          </div>
          
          {/* Decorative elements */}
          <div className="mt-12 flex justify-center">
            <div className="border border-cyan-400 w-32 h-2 mx-2"></div>
            <div className="border border-cyan-400 w-2 h-2 mx-2 rotate-45"></div>
            <div className="border border-cyan-400 w-32 h-2 mx-2"></div>
          </div>
        </div>
      </div>
    </div>
  );
}